import React, { useState } from 'react';
import MagicForm from '../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import Loading from '../../../../Components/Loading';
import { HealthPlanCode } from '../../../../Enums/HealthPlanCode.enum';
import { useEffectAsync } from '../../../../helpers';
import useWizardTree from '../../../../Hooks/useWizardTree';
import { FormStructure } from './HealthPlanQuestionnaireRevisionForm.interface';

interface HealthPlanQuestionnaireFormProps {
	onSubmit: (values: FormStructure) => void;
	userId: string;
	healthPlanCode: string | null;
	readOnly?: boolean;
}

const HealthPlanQuestionnaireForm: React.FC<
	HealthPlanQuestionnaireFormProps
> = ({ onSubmit, userId, healthPlanCode, readOnly }) => {
	const [scheme, setScheme] = useState<ItemScheme[]>([]);
	const [defaultValues, setDefaultValues] = useState(null);
	const [isInitialized, setIsInitialized] = useState(false);

	const { getWizard } = useWizardTree({
		wizardKey: 'health-plan-patient-questionnaire',
		params: {
			userId,
			healthPlanCode,
		},
	});

	useEffectAsync(async () => {
		const wizard = await getWizard();
		setScheme(wizard?.children || []);
		setDefaultValues(wizard?.settings?.defaultValues || null);
		setIsInitialized(true);
	}, []);

	if (!isInitialized) return <Loading />;

	return (
		<div className='col-12 col-lg-8'>
			<div className='page-panel mt-1 mb-1'>
				<MagicForm
					formScheme={scheme}
					defaultValues={defaultValues}
					onSubmit={onSubmit}
					readOnly={readOnly}
				/>
			</div>
		</div>
	);
};

export default HealthPlanQuestionnaireForm;
